import api from '@/utils/api';

/**
 * Update Company
 * @param {string} id Company id
 * @param {string} optionId Option id
 * @param {object} optionData - The Option data
 * @returns {Promise}
 */
const updateCompanyOptionApi = (id, optionId, optionData) =>
  api.patch(`/company/${id}/option/${optionId}`, optionData);

export default updateCompanyOptionApi;
